// Live price for configurable products: the shown price = selected variant price + selected paid extras.
// Re-runs on every option change and after the variant picker swaps the price partial.
const money = (cents, currency) =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency }).format(cents / 100);

// Extras dropdowns sit inside the variant partial, so remember choices and restore them after a swap.
const savedChoices = new Map();

function restoreChoices() {
  for (const select of document.querySelectorAll('select[data-addon-select]')) {
    const saved = savedChoices.get(select.name);
    if (saved == null || select.value === saved) continue;
    if ([...select.options].some((option) => option.value === saved)) select.value = saved;
  }
}


function update() {
  restoreChoices();
  const priceEl = document.querySelector('[data-product-price][data-base-price]');
  if (!priceEl) return;

  let extras = 0;
  for (const select of document.querySelectorAll('select[data-addon-select]')) {
    extras += Number(select.selectedOptions[0]?.dataset.addonPrice || 0);
  }

  const base = Number(priceEl.dataset.basePrice || 0);
  const compare = Number(priceEl.dataset.comparePrice || 0);
  const total = base + extras;
  const currency = window.Shopify?.currency?.active || 'CAD';
  const amounts = priceEl.querySelectorAll('bdi');
  if (!amounts.length) return;

  const totalText = money(total, currency);
  if (amounts[0].textContent !== totalText) amounts[0].textContent = totalText;

  // Keep the "(-xx%)" badge honest against the new total.
  if (compare > total && amounts.length >= 3) {
    const pct = `(-${Math.round(((compare - total) * 100) / compare)}%)`;
    const badge = amounts[amounts.length - 1];
    if (badge.textContent !== pct) badge.textContent = pct;
  }
}

document.addEventListener('change', (event) => {
  const target = event.target;
  if (target instanceof HTMLSelectElement && target.matches("[data-addon-select]")) savedChoices.set(target.name, target.value);
  if (target instanceof HTMLSelectElement) requestAnimationFrame(update);
});

let pending = false;
new MutationObserver(() => {
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => {
    pending = false;
    update();
  });
}).observe(document.body, { childList: true, subtree: true });

update();
